import React from "react";
import LowCodeBlock from "./LowCodeBlock";

/**
 * LAYOUT RENDERER
 *
 * Recursively renders layout structure (rows, columns, sections, blocks)
 * defined in the SuperApp config. Passes user context down to blocks
 * so they can render SuperAppObjects if needed.
 */

function renderRegion(region, blocks, user, userDeep) {
  if (!region) return null;
  if (Array.isArray(region)) {
    return region.map((item, idx) =>
      renderRegion(item, blocks, user, userDeep)
    );
  }

  const { type, id, sectionProps = {}, block } = region;
  const key = `${type || "section"}-${id || Math.random()}`;

  switch (type) {
    case "row":
      return (
        <div key={key} className="layout-row" style={sectionProps.style}>
          {renderRegion(region.children, blocks, user, userDeep)}
        </div>
      );
    case "column":
      return (
        <div key={key} className="layout-column" style={sectionProps.style}>
          {renderRegion(region.children, blocks, user, userDeep)}
        </div>
      );
    case "section":
      return (
        <section key={key} {...sectionProps}>
          {renderRegion(region.children, blocks, user, userDeep)}
        </section>
      );
    case "block":
      return (
        <LowCodeBlock
          key={key}
          definition={blocks?.[block || id || ""]}
          user={user}
          userDeep={userDeep}
        />
      );
    case "tabs":
      // For tabs, the structure itself contains the tabs definition
      // We can pass the whole region object as the definition to LowCodeBlock
      // but we need to ensure LowCodeBlock can access the blocks map for recursive rendering
      return (
        <LowCodeBlock
          key={key}
          definition={{ ...region, blocks }} // Pass blocks map down
          user={user}
          userDeep={userDeep}
        />
      );
    default:
      return (
        <div key={key} className="layout-section">
          {renderRegion(region.children, blocks, user, userDeep)}
        </div>
      );
  }
}

export default function LayoutRenderer({ layout, user, userDeep }) {
  if (!layout) return null;
  const { structure, blocks } = layout;

  return (
    <div className="layout-container custom-container">
      {renderRegion(structure, blocks, user, userDeep)}
    </div>
  );
}
